export const ReleaseInfo = Object.freeze({
  releaseVersion: '2026.2.12-1228.35',
  commitId: 'ac202ab7a0803865563046877f00f2e15cd35141',
  commitTime: '2026-02-12T12:28:35.000Z',
});
